<td *ngIf="idToSelect && allowSelection$ | async" class="checkbox-column">
  <lib-checkbox [checked]="isSelected$ | async" (change)="onSelectionChange($event)"></lib-checkbox>
</td>
<ng-content select="td"></ng-content>
